export interface ISubscriptionV2 {
  product_name: string;
  product_id: number;
  amount: string;
  payment_interval: string;
  payment_period: number;
  team_code?: string;
  subscription_discount?: string;
  discount_percentage: boolean;
  setup_discount?: string;
  additional_user_cost?: string;
  subscription_id: string;
  customer_id: string;
  paid_by_manager: boolean;
}

export interface ISubscription {
  id: number;
  coupon_id: string;
  team_code: string;
  plan_id: string;
  manager_account: boolean;
  subscription_cost: number;
  additional_user_cost: number;
  subs_description: string;
  expire: boolean;
  trial_days: number;
  content_code: string;
  campaign_name: string;
  campaign_type: string;
  credits: number;
  billing_frequency: string;
  user_contact_group: string;
  additional_user_plan: string;
  plan_cost: number;
  content_code2: string;
  campaign_name2: string;
  campaign_type2: string;
  user_contact_group2: string;
  content_code3: string;
  campaign_name3: string;
  campaign_type3: string;
  user_contact_group3: string;
  frequency: number;
  frequency2: number;
  frequency3: number;
}

export enum EBillingFrequency {
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  SEMI_ANNUALY = 'semi-annualy',
  ANNUALY = 'annualy',
}
